import { Cell } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const TypeCell = styled(Cell)<{ checked: boolean }>`
  div {
    padding: ${({ theme: { reference } }) => reference.dimension_24};
    background-color: ${({ theme: { colors } }) => colors.white};
    border-color: ${({ checked, theme: { system } }) =>
      checked ? system.accent.fds_sys_color_accent_cold : system.border.fds_sys_color_border_soft};
  }
`;
